export enum LayoutVariant {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
